import courseSkill from '@/api/academic/course-skill';

import { baseState, baseMutations } from '@/store/mixins';
import { isEmpty, split } from 'lodash';

export const state = {
    ...baseState,
    formViewDatas: [],
    is_closed: false
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_VIEW_MODELS(state, { data, index }) {
        if (!index) {
            state.formViewDatas = data;
        } else {
            split(index, ",").forEach(el => {
                state.formViewDatas[el] = data[el];
            });
        }
    },
    SET_STATUS(state, data) {
        state.is_closed = data
    }
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search,
                    is_closed: context.state.is_closed
                }
            },
            attrubutes
        )
        return courseSkill.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store(context, data) {
        return courseSkill.store(data)
    },
    async find(context, id) {
        if (isEmpty(context.state.edit_data)) {
            let response = await courseSkill.find(id)
            context.commit('SET_EDIT_DATA', response.data)
        }
    },
    update(context, { id, data }) {
        return courseSkill.update(id, data)
    },
    changeStatue(context, { id, data }) {
        return courseSkill.changeStatue(id, data)
    },
    destroy(context, id) {
        return courseSkill.destroy(id)
    },
    async getFormViewData(context, { params, index }) {
        let response = await courseSkill.formModel({ params: params });
        context.commit("SET_VIEW_MODELS", {
            data: response.data,
            index: index
        });
        return Promise.resolve(response);
    },
}
